import React from 'react';
import { compose, replace, defaultTo } from 'ramda';
import { number, string } from 'prop-types';

const toFixed = (value, lenght = 2) => value.toFixed(lenght);
const convertToBrCurrency = replace('.', ',');
const format = compose(convertToBrCurrency, toFixed, defaultTo(0));

function Money({ className, price }) {
  return <span className={className}>{`R$ ${format(price)}`}</span>;
}

Money.propTypes = {
  className: string,
  price: number,
};

Money.defaultProps = {
  className: '',
  price: 0.00,
};

export default Money;
